(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('atnt-daily-countdown')) {
    class AtntDailyCountdown extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        this._label = this.querySelector('[data-countdown-label]');
        this._timer = this.querySelector('[data-countdown-timer]');
        this._resume = this.querySelector('[data-countdown-resume]');
        this._formatter = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Paris',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23'
        });
        this._onVisibility = () => this.start();
        this._onPageShow = () => this.start();
        document.addEventListener('visibilitychange', this._onVisibility);
        window.addEventListener('pageshow', this._onPageShow);
        this._dialog = this.querySelector('[data-rewards-dialog]');
        this._openButton = this.querySelector('[data-rewards-open]');
        this._closeButton = this.querySelector('[data-rewards-close]');
        this._openRewards = () => this._dialog.showModal();
        this._closeRewards = () => this._dialog.close();
        this._clickBackdrop = event => {
          if (event.target !== this._dialog) return;
          const rect = this._dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this._dialog.close();
        };
        this._openButton.addEventListener('click', this._openRewards);
        this._closeButton.addEventListener('click', this._closeRewards);
        this._dialog.addEventListener('click', this._clickBackdrop);
        this.start();
      }
      disconnectedCallback() {
        this._openButton?.removeEventListener('click', this._openRewards);
        this._closeButton?.removeEventListener('click', this._closeRewards);
        this._dialog?.removeEventListener('click', this._clickBackdrop);
        if (this._dialog?.open) this._dialog.close();
        clearInterval(this._interval);
        document.removeEventListener('visibilitychange', this._onVisibility);
        window.removeEventListener('pageshow', this._onPageShow);
        this._connected = false;
      }
      start() {
        clearInterval(this._interval);
        this.update();
        if (!document.hidden) this._interval = setInterval(() => this.update(), 1000);
      }
      update() {
        const parts = this._formatter.formatToParts(new Date());
        const value = type => Number(parts.find(part => part.type === type).value);
        const elapsed = value('hour') * 3600 + value('minute') * 60 + value('second');
        const paused = elapsed < 3600;
        const remaining = paused ? 0 : 86400 - elapsed;
        const h = Math.floor(remaining / 3600);
        const m = Math.floor(remaining % 3600 / 60);
        const s = remaining % 60;
        const digits = [h, m, s].map(n => String(n).padStart(2, '0'));
        const display = `${digits[0]} h ${digits[1]} min ${digits[2]} s`;
        if (this._timer.textContent !== display) this._timer.textContent = display;
        this._timer.hidden = false;
        const label = paused ? this.dataset.pausedLabel : remaining <= 3600 ? this.dataset.lastHourLabel : this.dataset.activeLabel;
        if (this._label.textContent !== label) this._label.textContent = label;
        this._resume.hidden = !paused;
        this.dataset.state = paused ? 'paused' : 'active';
      }
    }
    customElements.define('atnt-daily-countdown', AtntDailyCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atnt-product-discovery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atnt-product-discovery')) {
    customElements.define('atnt-product-discovery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const grid = this.querySelector('[data-related-grid]');
        if (!grid) return;
        const cards = [...grid.querySelectorAll('[data-related-card]')].sort((a,b) => Number(b.dataset.score) - Number(a.dataset.score));
        let visible = 15;
        const more = this.querySelector('[data-discovery-more]');
        const update = () => {
          cards.forEach((card,index) => { card.hidden = index >= visible; });
          if (more) more.parentElement.hidden = visible >= cards.length;
        };
        cards.forEach(card => grid.append(card));
        update();
        more?.addEventListener('click', () => {
          const firstNew = cards[visible];
          visible += 15;
          update();
          const status = this.querySelector('[data-discovery-status]');
          status.textContent = status.dataset.template.replace('[count]', Math.min(visible, cards.length));
          firstNew?.querySelector('a')?.focus({preventScroll:true});
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
